import React from "react";
import UseContext from "hooks/useContext";
import SectionWrapper from "pages/createMission/components/SectionWrapper";

const Row = ({ label, value }) => (
    <div className={"flex justify-between gap-4 py-2 border-b border-gray-100"}>
        <div className={"ft-sm text-gray-500"}>{label}</div>
        <div className={"ft-sm text-gray-900 text-right"}>{value || "—"}</div>
    </div>
);

const formatList = (list) =>
    Array.isArray(list) && list.length > 0 ? list.join(", ") : "";

const formatAddress = (location) => {
    if (!location) return "";
    if (typeof location === "string") return location;
    const { street, postcode, city, department } = location;
    return [street, postcode, city, department].filter(Boolean).join(" ");
};

const ConfirmationTemplate = () => {
    const { templateData } = UseContext();

    return (
        <div className={"flex flex-col gap-6"}>
            <SectionWrapper
                title="Confirmation"
                description="Vérifiez les informations de la fiche de poste avant de l'enregistrer."
            >
                <div className={"flex flex-col"}>
                    <Row label={"Nom du modèle"} value={templateData.name} />
                    <Row label={"Secteur"} value={templateData.activity} />
                    <Row
                        label={"Qualification"}
                        value={templateData.qualification}
                    />
                    <Row
                        label={"Matériel"}
                        value={formatList(templateData.tools)}
                    />
                    <Row
                        label={"Permis"}
                        value={formatList(templateData.licences)}
                    />
                    <Row
                        label={"Langues"}
                        value={formatList(templateData.languages)}
                    />
                    <Row
                        label={"Adresse"}
                        value={formatAddress(templateData.location)}
                    />
                    <Row
                        label={"Taux horaire brut"}
                        value={
                            templateData.salary
                                ? `${templateData.salary} €/h${
                                      templateData.isIndexedToMinimumWage
                                          ? " (indexé au SMIC)"
                                          : ""
                                  }`
                                : ""
                        }
                    />
                    <Row
                        label={"Responsable"}
                        value={
                            templateData.contact_name
                                ? `${templateData.contact_name}${
                                      templateData.contact_poste
                                          ? ` — ${templateData.contact_poste}`
                                          : ""
                                  }`
                                : ""
                        }
                    />
                    <Row label={"Notes intérimaire"} value={templateData.other} />
                    <Row
                        label={"Notes agence"}
                        value={templateData.other_interim}
                    />
                </div>
            </SectionWrapper>
        </div>
    );
};

export default ConfirmationTemplate;
